import React from 'react';
import PropTypes from 'prop-types';

import HeaderDropdown from '../../../common/HeaderDropdown';
import { DROPDOWNS } from './constants';

const SettingsHeaderDropdown = ({
  title,
  settingsItems,
  paymentItems,
  activeDropdown,
}) => (
  <div className="u-flex">
    <HeaderDropdown
      title={activeDropdown === DROPDOWNS.PAYMENTS ? title : 'Payments'}
      items={paymentItems}
      display-if={!!paymentItems && paymentItems.length}
      closeOnClickOutside
    />
    <HeaderDropdown
      title={activeDropdown === DROPDOWNS.SETTINGS ? title : 'Settings'}
      items={settingsItems}
      closeOnClickOutside
    />
  </div>
);

SettingsHeaderDropdown.propTypes = {
  title: PropTypes.string,
  settingsItems: PropTypes.array.isRequired,
  paymentItems: PropTypes.array,
  activeDropdown: PropTypes.string.isRequired,
};

SettingsHeaderDropdown.defaultProps = {
  title: 'Settings',
  paymentItems: null,
};

export default SettingsHeaderDropdown;
